export const REQUEST_PAYMENT_RECEIPT = 'REQUEST_PAYMENT_RECEIPT'
export const SET_PAYMENT_LIST = 'SET_PAYMENT_LIST'
export const SET_MAIN_PAYMENT_LIST = 'SET_MAIN_PAYMENT_LIST'